import { useEffect } from "react"

export const SIDEBAR_TOGGLE_SHORTCUT = "⌘\\"

export function useSidebarToggleShortcut(onToggle: () => void) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.code !== "Backslash" || !(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey || e.repeat) return
      e.preventDefault()
      onToggle()
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [onToggle])
}
